import {
  FAB_SHOW,
} from "cityads-v3/actions/fab";

const initialState = {
  show: true,
};

export default function fab(state = initialState, action = {}) {
  switch (action.type) {
    case FAB_SHOW:
      return {
        ...state,
        show: action.show
      };
    default:
      return state;
  }
}
